var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "GB_svg__a",
  width: 21,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 .5H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#GB_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#22438B",
  d: "M19 .5H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m3 1.5-2.026.026L1 3.5l16.982 11.028 2.037-.037-.038-1.962z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7152A",
  fillRule: "evenodd",
  d: "m2 1.5-1 1 18 12 1-1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18 1.5h2v2S8.25 10.896 3.018 14.528c-.063.044-1.998.003-1.998.003L.865 12.63z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7152A",
  fillRule: "evenodd",
  d: "M19.043 1.472 20 2.5l-18 12-1-1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 1.5h5v4h7v5h-7v4H8v-4H1v-5h7z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7152A",
  fillRule: "evenodd",
  d: "M9 1.5h3v5h8v3h-8v5H9v-5H1v-3h8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.1,
  d: "M19 1H2A1.5 1.5 0 0 0 .5 2.5v11A1.5 1.5 0 0 0 2 15h17a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 19 1Z"
}))));
export { SvgGb as ReactComponent };
export default "data:image/svg+xml;base64,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";